import {RcfaComplianceLocationHistory, RcfaComplianceLocationNode} from '@domain/rcfa'
import {buildFeatureUrl} from '@hproduce/suite-core'

export const findPathToNode = (
  nodes: RcfaComplianceLocationNode[],
  targetId: string,
  path: RcfaComplianceLocationHistory[] = []
): RcfaComplianceLocationHistory[] | null => {
  for (const node of nodes) {
    const newPath = [...path, {id: node.id, name: node.name}]
    if (node.id === targetId) return newPath
    if (node.subLocations) {
      const result = findPathToNode(node.subLocations, targetId, newPath)
      if (result) return result
    }
  }
  return null
}

export const resolveNavigationFromHistory = (
  rootLocation: RcfaComplianceLocationNode[],
  locationHistory: RcfaComplianceLocationHistory[],
  targetId: string
): {
  newHistory: RcfaComplianceLocationHistory[]
  siblings: RcfaComplianceLocationHistory[]
} | null => {
  const indexInHistory = locationHistory.findIndex((location) => location.id === targetId)

  if (indexInHistory === -1) return null

  const newHistory = locationHistory.slice(0, indexInHistory + 1)
  const parentPath = locationHistory.slice(0, indexInHistory)

  const parent = parentPath.reduce<RcfaComplianceLocationNode | RcfaComplianceLocationNode[]>(
    (current, id) => {
      if (!current) return rootLocation
      if (Array.isArray(current)) {
        return current.find((node) => node.id === id.id)?.subLocations || []
      }
      return current.subLocations?.find((node) => node.id === id.id)?.subLocations || []
    },
    rootLocation
  )

  let siblings: RcfaComplianceLocationHistory[] = []

  if (Array.isArray(parent)) {
    siblings = parent.map(({id, name}) => ({id, name}))
  } else if (parent && 'subLocations' in parent && Array.isArray(parent.subLocations)) {
    siblings = parent.subLocations.map(({id, name}) => ({id, name}))
  }

  return {
    newHistory,
    siblings
  }
}

export const getStoppagesListUrl = (plantId: string, upmPlantId: string) => {
  const baseUrl = buildFeatureUrl('StoppageList', upmPlantId)

  const filters = [{property: 'plantId', values: [plantId], operation: 'In'}]

  const search = new URLSearchParams({filters: JSON.stringify(filters), page: '0'}).toString()

  return `${baseUrl}?${search}`
}
